import { render, staticRenderFns } from "./OutcomesTables.vue?vue&type=template&id=31ebf566"
import script from "./OutcomesTables.vue?vue&type=script&lang=js"
export * from "./OutcomesTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports